import React from "react";
import { FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import { AntInput } from "../../../CommonElements/AntInput";
import { useTranslation } from "react-i18next";

export const TransportationForm = (props) => {
  const { control, errors } = props;
  const { t } = useTranslation();

  return (
    <>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="name"
          rules={{
            required: t("TRANSPORTATION_NAME_REQUIRED"),
          }}
          render={({ field }) => (
            <>
              <Label for="name">{t("TRANSPORTATION_NAME")}</Label>
              <AntInput
                type="text"
                id="name"
                name="name"
                {...field}
                placeholder={t("TRANSPORTATION_NAME_PLACEHOLDER")}
              />
              {errors.name && (
                <div className="text-danger">{errors.name.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
      <FormGroup className="mb-3">
        <Controller
          control={control}
          name="code"
          rules={{
            required: t("TRANSPORTATION_CODE_REQUIRED"),
            pattern: {
              value: /^[a-zA-Z0-9_-]+$/,
              message: t("TRANSPORTATION_CODE_INVALID"),
            },
          }}
          render={({ field }) => (
            <>
              <Label for="code">{t("TRANSPORTATION_CODE")}</Label>
              <AntInput
                type="text"
                id="code"
                name="code"
                {...field}
                placeholder={t("TRANSPORTATION_CODE_PLACEHOLDER")}
              />
              {errors.code && (
                <div className="text-danger">{errors.code.message}</div>
              )}
            </>
          )}
        />
      </FormGroup>
    </>
  );
};

